/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-30 12:47:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchContentSearchPage } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/slice';
import { useCloneBtnParams } from 'src/hooks/useCloneBtnParams';
import style from '../css.less';

const CloneBtn = (props) => {
  const params: any = useParams();
  const { contentUuid } = params;
  const _d = useDispatch();
  const _params = useCloneBtnParams();

  const handleOnClick = () => {
    _d(
      fetchContentSearchPage({
        //1===true 0===false
        uuid: contentUuid,
        params: _params,
        isClone: true,
      }),
    );
  };
  return (
    <Button
      onClick={handleOnClick}
      disabled={props?.disabled}
      className={style.cloneBtnWidth}
    />
  );
};
export default CloneBtn;
